import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { createMappingByKey, sortProductionComponentInstances } from '@paragon/production-app-utilities';

import { RootState } from '../store';

export const getProductionComponentInstancesByBundleGuid = createSelector(
  (state: RootState) => state.bundles,
  (state: RootState) => state.productionComponentInstances,

  (bundles, productionComponentInstances) =>
    mapValues(
      createMappingByKey(
        productionComponentInstances,
        (productionComponentInstance) => productionComponentInstance.bundleGuid,
        bundles,
      ),
      (instances) => instances.toSorted(sortProductionComponentInstances),
    ),
);
